import { computed, type ComputedRef } from 'vue';
import { useRemoteConfigStore } from '../stores/remoteConfig.store';

/**
 * Indica si la empresa tiene acceso a Wallet Stablecoins v3 (BTC y ETH).
 * Una empresa habilitada por segmentación (empresa o país) recién obtiene acceso
 * cuando carga su KYC; sin Remote Config, nadie tiene acceso.
 */
export function useCanAccessWalletStablecoinsV3(): ComputedRef<boolean> {
  const remoteConfigStore = useRemoteConfigStore();
  const walletStablecoinsV3Flag = remoteConfigStore.getFeatureFlag(
    'feature_wallet_stablecoins_v3'
  );

  return computed<boolean>(() => walletStablecoinsV3Flag.value.enabled);
}
